import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    template: `
        <div *ngIf="isLoading" style="display: flex; align-items: center; justify-content: center; height: 100%;"><mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner></div>
        <button *ngIf="!isLoading" mat-icon-button (click)="onImport()">
            <mat-icon>check</mat-icon>
        </button>
    `
})
export class InboxActionCellRendererComponent implements ICellRendererAngularComp {
    public params: any;
    public isLoading = false;

    agInit(params: any): void {
        this.params = params;
        this.isLoading = params.context.componentParent.isInboxEntryImporting(params.data.id);
    }

    public onImport(): void {
        this.params.context.componentParent.onImportCaseFromInbox(this.params.data);
    }

    public onReject(): void {
        this.params.context.componentParent.onRejectCaseFromInbox(this.params.data);
    }

    refresh(): boolean {
        return false;
    }
}
